export default __webpack_public_path__ + "930cf2e99bc548140c2954ce3e4d11b7.jpg";